import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

export function getVersoes(SEGCODIGO, FILTER) {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token')
        }
    }

    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/listaversoes", {SEGCODIGO, FILTER}, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(resposta.data.Rows)
            }
        })
    })
}
